$ ->
  loginTitle = __ 'account.login'
  resetTitle = __ 'account.reset_password'
  formTitle = $ '.login__descr'

  $(document).on 'ready', ->
    if document.location.hash.match /#forgot/
      $('[data-auth-target-switcher]').trigger 'click'

  $('[data-auth-target-switcher]').on 'click', (e) ->
    e.preventDefault()

    $('[data-auth-action="reset-result"]').html('')

    email = $('input[name="username"]').val()
    $('input[name="reset_email"]').val(email)

    $('[data-auth-target]').toggleClass('hidden')
    if loginTitle == formTitle.text().trim()
      formTitle.text resetTitle
    else
      formTitle.text loginTitle

  $('[data-auth-action="reset"]').on 'click', (e) ->
    e.preventDefault()
    button = $ @
    button_text = button.text()
    result_wrapper = $ '[data-auth-action="reset-result"]'
    lang = $('html').attr('lang')
    reset_email = $('input[name="reset_email"]').val()

    $.ajax({
      url: '/ajax/forgot_password'
      type: 'post'
      data:
        lang: lang
        reset_email: reset_email
      dataType: "json"
      beforeSend: () ->
        result_wrapper.html ''
        button.prop('disabled', on).html('<i class="fa fa-circle-o-notch fa-spin"></i>')
      complete: () ->
        button.text(button_text).removeClass('disabled').prop 'disabled', no
      success: (data) ->
        if data
          if data.success
            result_wrapper.html """<div class='info-message'>#{data.success}</div>"""
          else if data.error
            result_wrapper.html """<div class='error-message'>#{data.error}</div>"""
    });